import React, { Component } from 'react';
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem, MDBNavLink, MDBCollapse, MDBContainer,
MDBHamburgerToggler } from 'mdbreact';
import'./Nav.css'


class Navbar extends Component {
state = {
  collapse1: false,
  collapseID: ''
}

toggleCollapse = collapseID => () => {
  this.setState(prevState => ({ collapseID: (prevState.collapseID !== collapseID ? collapseID : '') }));
}

toggleSingleCollapse = collapseId => {
  this.setState({
    ...this.state,
    [collapseId]: !this.state[collapseId]
  });
}

render() {
  return (
        <MDBNavbar className="navbar navbar-expand-lg pl-3 mt-0 bg-dark" style={{ marginTop: '20px' }} light>
            <MDBNavbarBrand className="m-0">
              <MDBNavLink to="/" className="navbar-brand m-0 p-0">ElectroCenter</MDBNavLink>
            </MDBNavbarBrand>
            <MDBHamburgerToggler className="d-sm-inline d-lg-none" color="#3fa9f5" id="hamburger1" onClick={()=> this.toggleSingleCollapse('collapse1')} />
              <MDBCollapse isOpen={this.state.collapse1} navbar>
                <MDBNavbarNav className="container" >
                  <MDBNavItem>
                    <MDBNavLink to="/TVs">TV</MDBNavLink>
                  </MDBNavItem>
                  <MDBNavItem>
                    <MDBNavLink to="/Laptops">Laptops</MDBNavLink>
                  </MDBNavItem>
                  <MDBNavItem>
                    <MDBNavLink to="/Tablets">Tablets</MDBNavLink>
                  </MDBNavItem>
                  <MDBNavItem>
                    <MDBNavLink to="/Phones">Phones</MDBNavLink>
                  </MDBNavItem>
                  <MDBNavItem>
                    <MDBNavLink to="/Consoles">Consoles</MDBNavLink>
                  </MDBNavItem>
                  <MDBNavItem>
                    <MDBNavLink to="/Accessories">Accessories</MDBNavLink>
                  </MDBNavItem>
                  </MDBNavbarNav>
                  {/* <form className="form-inline d-sm-none d-md-none d-lg-inline my-2 my-lg-0">
                      <input className="form-control mr-sm-1" type="search" placeholder="Search" aria-label="Search"/>
                      <button className="btn btn-outline-primary my-2 my-sm-0" type="submit"><i className="fas fa-search"></i></button>
                  </form> */}
                    <MDBNavLink to="/Cart"><i className="fas fa-shopping-cart my-auto"></i></MDBNavLink>
              </MDBCollapse>
        </MDBNavbar>
    );
  }
}

export default Navbar;